module.exports = __webpack_public_path__ + "47edfbff3f0a4324d9ba51bc28605fb6.svg";